import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MicrosoftSecurityGroupMembership } from '../models/generated/ziroModels';

@Injectable()
export class Microsoft365SecurityGroupsContext {
  protected http = inject(HttpClient);

  private _stateSource = new ReplaySubject<MicrosoftSecurityGroupMembership>(1);
  state$ = this._stateSource.asObservable();

  get(tenantId: string, userPrincipalName: string): Observable<MicrosoftSecurityGroupMembership> {
    return this.http
      .get<MicrosoftSecurityGroupMembership>(
        `/services/microsoft/macs/tenants/${tenantId}/security-group-memberships/${userPrincipalName}`,
      )
      .pipe(
        tap((userGroups: MicrosoftSecurityGroupMembership) => {
          this._stateSource.next(userGroups);
        }),
      );
  }

  updateUserGroups(
    tenantId: string,
    userPrincipalName: string,
    microsoft365GroupMembership: MicrosoftSecurityGroupMembership,
  ): Observable<void> {
    return this.http
      .put<void>(
        `/services/microsoft/macs/tenants/${tenantId}/security-group-memberships/${userPrincipalName}`,
        microsoft365GroupMembership,
      )
      .pipe(
        tap(() => {
          this._stateSource.next(microsoft365GroupMembership);
        }),
      );
  }
}
